import { render } from "./TranslateInput.vue?vue&type=template&id=4d0d379e"
import script from "./TranslateInput.vue?vue&type=script&lang=js"
export * from "./TranslateInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__